export const parseNumber = value => Number(String(value).replace(',', '.'))
